// extracted by mini-css-extract-plugin
export default {"content":"JobsList_content__G73ji","search":"JobsList_search__jVCKq"};